/**
 * BigPhotoAndDescription component
 * @returns <BigPhotoAndDescription />
 */
import Button from "./Button"

const BigPhotoAndDescription = (props) => {
    const { photo, items } = props;

    return (
        <div className={`big-photo-and-description --store-version ${photo ? photo : "right"}`}>
            {items.map((item, i) => {
                return (
                    <div className="big-photo-and-description_element" key={i}>
                        <img src={item.image} alt={item.title} className={`big-photo-and-description_element-img ${item.btnConfig ? "--with-button" : ""}`} />

                        <div className="wrapper">
                            <div className={`big-photo-and-description_element-text ${item.btnConfig ? "--with-button" : ""}`}>
                                {item.btnConfig
                                    ?
                                    <h3 className="title"><strong>{item.title}</strong></h3>
                                    :
                                    <p className="title"><strong>{item.title}</strong></p>
                                }

                                <p className="subtitle">{item.subtitle}</p>

                                <div className="line"></div>

                                <p className="description">{item.description}</p>

                                {item.btnConfig && <Button {...item.btnConfig} />}
                            </div>
                        </div>
                    </div>
                )
            })}
        </div>
    )
}

export default BigPhotoAndDescription